// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HasSeenAd":"co_a bhp_fm bhp_vv bhp_xg bhp_h"};